import { useState, useEffect } from 'react';
import api from '@/lib/api';

// Flujo de estados POR FORMA (Excel "Office Work Flow (2)": Permit Application /
// Completion Report → Draft·Send·Signed·Submitted for approval·Pending·Approved,
// NOC → Draft·Stamped·Pending·Done, NTO → Draft·Send·Pending·Certify·Done).
// El backend siembra el flujo de cualquier forma nueva automáticamente.
const FALLBACK = [
  { key: 'draft', label: 'New', is_final: false },
  { key: 'sent', label: 'Sent', is_final: false },
  { key: 'signed', label: 'Signed', is_final: false },
  { key: 'submitted_for_approval', label: 'Submitted for Approval', is_final: false },
  { key: 'pending', label: 'Pending', is_final: false },
  { key: 'granted', label: 'Approved', is_final: true },
];

let _cache = null;
let _inflight = null;

async function fetchFlows() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = api.get('/job-status/form-flows').then(res => {
    _cache = res.data || [];
    _inflight = null;
    return _cache;
  }).catch(() => { _inflight = null; return []; });
  return _inflight;
}

export function invalidateFormFlowsCache() { _cache = null; }

/** Etiqueta de un status de forma: SIEMPRE la que Alian ve/edita en Settings
 *  (el Excel usa "Send", "Approved", "Stamped", "Certify", "Done"). */
export function formStatusLabel(s) {
  if (!s) return '';
  return s.label || s.key;
}

/** Returns { flows, flowFor(formId) } — flowFor always returns a non-empty list. */
export function useFormStatusFlows() {
  const [flows, setFlows] = useState(_cache || []);

  useEffect(() => {
    let mounted = true;
    fetchFlows().then(f => { if (mounted) setFlows(f); });
    return () => { mounted = false; };
  }, []);

  const flowFor = (formId) => {
    const found = flows.find(f => f.form_id === formId);
    return (found && found.statuses?.length) ? found.statuses : FALLBACK;
  };

  return { flows, flowFor, refresh: async () => { _cache = null; const f = await fetchFlows(); setFlows(f); return f; } };
}

export const FORM_STATUS_STYLES = {
  empty: 'bg-gray-50 text-gray-400 border-gray-200',
  '': 'bg-gray-50 text-gray-400 border-gray-200',
  draft: 'bg-amber-50 text-amber-700 border-amber-300',
  sent: 'bg-blue-50 text-blue-700 border-blue-300',
  signed: 'bg-indigo-50 text-indigo-700 border-indigo-300',
  submitted_for_approval: 'bg-purple-50 text-purple-700 border-purple-300',
  pending: 'bg-orange-50 text-orange-700 border-orange-300',
  stamped: 'bg-cyan-50 text-cyan-700 border-cyan-300',
  certify: 'bg-teal-50 text-teal-700 border-teal-300',
  done: 'bg-emerald-50 text-emerald-700 border-emerald-300',
  granted: 'bg-emerald-50 text-emerald-700 border-emerald-300',
};
